<template>
  <div>
    <multi-select
      :data="data"
      :multi-select="multiSelect"
      :preselected="preselected"
      :is-shortened="isShortened"
      :placeholder="placeholder"
      :label="label"
      :value="value"
      @change="onchange"
      @input="oninput"
    />
  </div>
</template>

<script>
/* eslint-disable */
import MultiSelect from '@/components/elements/inputs/multiSelect.vue';
import financeTypes from '@/data/financeTypes';

export default {
  name: 'financeTypeSelect',
  components: { MultiSelect },
  props: {
    multiSelect: {
      type: Boolean,
      default: false,
    },
    preselected: {
      type: Array
    },
    isShortened: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    data() {
      return financeTypes
    }
  },
  methods: {
    onchange(val) {
      this.$emit('change', val);
    },
    oninput(val) {
      this.$emit('input', val);
    },
  }
}
</script>

<style scoped>

</style>
